// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/neue-auszubildende-in-fuersteneck/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const neueAuszubildendeInFuersteneckDE: PageEntry = {
  id: "post.neue-auszubildende-in-fuersteneck",
  locale: "de",
  slug: "neue-auszubildende-in-fuersteneck",
  seo: {
    title: "Neue Auszubildende in Fürsteneck | Dietz GmbH",
    description: "Neue Auszubildende in Fürsteneck",
  },
  type: "post",
  h1: "Neue Auszubildende in Fürsteneck",
  blocks: [
    { kind: "heading", level: 2, text: "Neue Auszubildende in Fürsteneck" },
    { kind: "paragraph", text: "Zum ersten Mal haben unsere neuen Auszubildenden in Fürsteneck ein Seminar zum Thema „Der Betrieb – mein neuer Alltag“ belegt. Insgesamt haben sich hier eine Woche lang 40 Auszubildende aus vier verschiedenen Unternehmen mit diversen Projekten zu den unterschiedlichsten Themen beschäftigt. Der Fokus der Projektarbeiten lag hier bei der Zusammenarbeit in unterschiedlichen Teams." }
  ],
};
